import React, { Component, createRef } from "react";

import ReactModal from 'react-modal';
import "./PlanInstances.less";
import StudentModal from "../PlanStep3/StudentModal";

import { Player } from 'video-react';
import "../../../../node_modules/video-react/dist/video-react.css";
import TeacherAbilityDisplay from "../TeacherAbilityDisplay";

import { withTranslation } from 'react-i18next';
class InstanceView extends Component {
  constructor(props) {
    super(props);

    const { id, step, videos, photos, resources, students, ownerTeacher, creator } = this.props;

    this.state = {
      id: id ? id : null,
      step: step ? step : '',
      ownerTeacher: ownerTeacher,
      videos: videos ? videos : [],
      photos: photos ? photos : [],
      creator: creator || '',
      resources: resources ? resources : [],
      students: students ? students : [],
      isReactModalOpen: false,
      isReactModalContent: <div></div>,
      reactModalHeight: "30vh",

    }


    this.modal = createRef();
  }

  getName = () => {
    let name = '';
    const { teachers, creator } = this.props;

    if (teachers && creator) {
      let teacher = teachers.filter(t => t.GUID === creator)
      name = teacher[0].firstName + '' + teacher[0].lastName;
    }

    return name;
  }

  getStepName = () => {

    const { planSetting, step } = this.props;

    let list = planSetting.lessonPlanSteps.filter(s => s._id === step)
    let s = ''

    if (list[0]) s = list[0].stepName

    return <p>{s}</p>
  }

  openModal = (data, targetKey) => {

    console.log('currentStudentPlan =>', data)
    this.setState({
      currentStudentPlan: data,
      showModal: true,
      targetKey: targetKey
    })
  }

  closeModal = (e) => {
    this.setState({ showModal: false });
  }


  render() {

    const { planSetting, videos = [], photos = [], resources = [], students = [], step, t, approveStep2 } = this.props;
    // const { teachers = [] } = this.props;
    const { currentStudentPlan = {}, targetKey } = this.state

    return (
      <div className="instancesBody">
        <table border="1" className="instancesTable">
          <tbody>
            <tr>
              <td colSpan="2">
                <div className="tableHeader" >
                  <i className="fas fa-align-justify" /> {" "}
                </div>
              </td>
            </tr>
            <tr>
              <td className="instancesTitle">{t('step2.teacher')}</td>
              <td><div className="creatorDiv">{this.getName()}</div></td>
            </tr>
            <tr>
              <td className="instancesTitle">{t('step2.step')}</td>
              <td>
                {
                  (step && planSetting && planSetting.lessonPlanSteps) &&
                  this.getStepName()
                }
              </td>
            </tr>
            <tr>
              <td className="instancesTitle">
                <div>
                  <span className="notice">*</span>{t('step1.teacherAbilityLabel')}
                </div>
              </td>
              <td>
                {this.props.planSetting && this.props.teacherAbility && this.props.teacherAbility[this.props.step] && <TeacherAbilityDisplay teacherAbilityPointers={this.props.planSetting.teacherAbilityPointers}
                  currentPosition={this.props.step}
                  teacherAbility={this.props.teacherAbility[this.props.step]} />}
              </td>
            </tr>
            <tr>
              <td className="instancesTitle">{t('step2.video')}</td>
              <td>
                <div className="videoList">
                  { // 已上傳影片區
                    videos &&
                    videos.map((i, k) =>
                      <div className="videoItem" key={k}>
                        {/* <video className="video" controls>
                          <source src={window.CONFS.storageUrl + "/" + i.path} type="video/mp4" />
                          Your browser does not support HTML5 video.
                        </video> */}
                        <Player
                          playsInline
                          className="video"
                          poster={window.CONFS.storageUrl + "/" + i.path}
                          src={window.CONFS.storageUrl + "/" + i.path}
                        />
                        <div className="video__content">
                          <div className="video__content__title"><a href={window.CONFS.storageUrl + "/" + i.path} target="_blank">{i.fileName || ''}</a></div>
                          <div className="video__content__desc">{i.description || ''}</div>
                        </div>
                      </div>
                      // <div key={k}>
                      //   {/* <video className="videoShow" alt={i.description || ''} src={this.state.videos && "https://storage.hisoft.site/" + i.path}></video> */}
                      //   <button className="removeBtn" onClick={() => this.removeTargetElement(k, 'videos')}><img className="videoList" src='data:image/png;base64,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' alt=""></img></button>
                      //   <i className="fas fa-times"></i>
                      //   {/* {i.fileName} */}
                      // </div>
                    )
                  }
                </div>
              </td>
            </tr>
            <tr>
              <td className="instancesTitle">{t('step2.photo')}</td>
              <td>
                <div className="photoList">
                  { // 已上傳photo
                    photos &&
                    photos.map((i, k) =>
                      <div className="photoItem" key={k}>
                        <div className="photo" style={{ "backgroundImage": "url(" + window.CONFS.storageUrl + "/" + i.path + ")" }}></div>
                        <div className="photo__content">
                          <div className="photo__content__title">{i.fileName || ''}</div>
                          <div className="photo__content__desc">{i.description || ''}</div>
                        </div>
                      </div>
                    )
                  }
                </div>
              </td>
            </tr>
            <tr>
              <td className="instancesTitle">{t('step2.resource')}</td>
              <td>
                {
                  resources &&
                  <>
                    {resources.map((item, k) => {
                      return (<div className="resource-item" key={k} title={this.getTitle(item)}>
                        <a href={item.url} target="_blank" rel="noopener noreferrer">{item.name}</a>
                      </div>)
                    })
                    }
                  </>
                }
              </td>
            </tr>
            <tr>
              <td className="instancesTitle">{t('step2.studentAchievement')}</td>
              <td>
                <div>
                  <table border="1" className="student">
                    <thead>
                      <tr>
                        <td>{t('step2.name')}</td>
                        <td>{t('step2.plan')}</td>
                        <td>{t('step2.studentVideo')}</td>
                        <td>{t('step2.studentPhoto')}</td>
                        <td>{t('step2.studentFile')}</td>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        students &&
                        this.state.students.map((i, k) =>
                          <tr key={k}>
                            <td>
                              <button onClick={() => this.openModal(i, k)} className="editorBtn" >查看</button>
                            </td>
                            <td><div>{i.name}</div></td>
                            <td>{i.plans && i.plans.length}</td>
                            <td>{i.videos && i.videos.length}</td>
                            <td>{i.photos && i.photos.length}</td>
                            <td>{i.files && i.files.length}</td>
                          </tr>
                        )
                      }
                    </tbody>
                  </table>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        {
          this.state.showModal &&
          <StudentModal
            currentStudentPlan={currentStudentPlan}
            // teachers={teachers} 
            closeModal={this.closeModal}
            updateStudents={this.updateStudents}
            removeStudent={this.removeStudent}
            targetKey={targetKey}
            approveStep2={approveStep2}
            loginRole={this.props.loginRole}
          />
        }
        <ReactModal
          isOpen={this.state.isReactModalOpen}
          shouldCloseOnOverlayClick={true}
          onRequestClose={() => { this.setState({ isReactModalOpen: false }) }}
          style={{ overlay: { "background": "#000000a3" }, content: { "width": "75%", "height": this.state.reactModalHeight, "margin": "0 auto" } }}
        >
          <div className="modalControllArea">
            <div id="modalCloseBtn" onClick={() => { this.setState({ isReactModalOpen: false }) }}>
              <i className="fas fa-times" style={{ "fontSize": "25px" }}></i>
            </div>
          </div>
          {this.state.isReactModalContent}
        </ReactModal>
      </div>
    );
  }

  getTitle = (resource) => {
    let classNames = resource.classes ? resource.classes.map(classObject => { return `${classObject.title.tw} ${classObject.removed ? '(removed)' : ''}` }) : []
    return `${classNames} \n\r ${resource.description || ''}`
  }
}

export default withTranslation()(InstanceView);